import ModelRepositoryListCard from '@/components/ModelRepositoryListCard'
import React from 'react'

export default function OrganizationModelRepositories() {
    return <ModelRepositoryListCard />
}
